import { render, staticRenderFns } from "./NavTooltip.vue?vue&type=template&id=66331421&scoped=true&"
import script from "./NavTooltip.vue?vue&type=script&lang=ts&"
export * from "./NavTooltip.vue?vue&type=script&lang=ts&"
import style0 from "./NavTooltip.vue?vue&type=style&index=0&id=66331421&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66331421",
  null
  
)

export default component.exports
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QTooltip});
